(function (global, factory) {
    if (!global) {
        throw new Error("main.js Requires window or a global object");
    }

    var document = global.document,
        jquery = global.jQuery;

    if (!document) {
        throw new Error("main.js requires a window or global object with a document");
    }

    if (!jquery) {
        throw new Error("main.js requires a jQuery, it miss in  window or global object");
    }

    factory(jquery, global, document);
    // Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this,
    function ($, window, document, undefined) {

        function AeMain() {
            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);

            var jsonFile = globalVariables.basePath + "/content/data/{0}.json?v=" + new Date().getTime();
            var baseBrochurePath = globalVariables.basePath + "/content/docs/{0}/";
            var baseModelsImagesPath = globalVariables.basePath + "/content/images/models/";
            var basePreviewPath = globalVariables.basePath + "/content/images/brochures/{0}/";
            var baseMenuIconsPath = globalVariables.basePath + "/content/images/icons/models/";

            /*** TEMPLATES ***/
            const modelTemplate = ({
                modelUrl,
                modelImage,
                modelText,
                modelName,
                buttonText
            }) => `<div class="col-12 col-lg-6 col-xl-4">
                        <div class="ae-model">
                        <a href="${modelUrl}">
                            <img loading="lazy" src="${modelImage}" /> 
                            <div class="ae-model-text">
                                <h3>${modelName}</h3>
                                <p>${modelText}</p>
                            </div>
                        </a>
                        <div class="ae-model-bottom">
                            <a class="btn btn-primary" href="${modelUrl}">${buttonText}</a>
                        </div>
                        </div>
                    </div>`;


            const brochureTemplate = ({
                documentUrl,
                shareUrl,
                shareText,
                documentPreview,
                documentText,
                documentSize,
                buttonDownloadText,
                buttonShareText,
                disabled
            }) => `<div class="col-12 col-md-6 col-lg-4"><div class="ae-brochure">
                        <a ${disabled} href="${documentUrl}" target="_blank">
                            <img loading="lazy" src="${documentPreview}" /> 
                            <div class="ae-brochure-text">
                                <h3>${documentText}</h3>
                                <p>${documentSize}</p>
                            </div>
                        </a>
                        <div class="ae-brochure-buttons">
                            <a ${disabled} class="ae-btn-share a2a_dd" target="_blank" data-a2a-url="${shareUrl}" data-a2a-title="${shareText}" href="https://www.addtoany.com/share">${buttonShareText}</a>
                            <a ${disabled} class="ae-btn-dowload" target="_blank" href="${documentUrl}">${buttonDownloadText}</a>
                        </div>
                    </div></div>`;

            const navigationMenuItem = ({
                linkText,
                linkUrl,
                iconUrl,
                activeClass,
                ariaCurrent
            }) => `<a class="nav-link ${activeClass}" ${ariaCurrent} href="${linkUrl}"><span class="ae-icon-wrapper" style="-webkit-mask-image: url(${iconUrl})"></span>${linkText}</a>`

            const navigationMenuMobileSelectedItem = ({
                linkText,
                iconUrl
            }) => `<span class="ae-icon-wrapper" style="-webkit-mask-image: url(${iconUrl});"></span> ${linkText}`

            const navigationMenuMobileItem = ({
                linkText,
                iconUrl,
                linkUrl
            }) => `<li><a class="dropdown-item" href="${linkUrl}"><span class="ae-icon-wrapper" style="-webkit-mask-image: url(${iconUrl})"></span>${linkText}</a></li>`

            function ReadJson(lang) {
                $.getJSON(jsonFile.replace("{0}", lang), function (data) {
                    var brochureDownloadButtonText = data["BrochureDownloadButtonText"];
                    var brochureShareButtonText = data["BrochureShareButtonText"];
                    var modelButtonText = data["ModelButtonText"];

                    var pages = globalVariables.pag.toLowerCase().split("/");

                    if (pages[0].length === 0) {
                        //No category -> Redirect to default category
                        location.href = globalVariables.basePath + "/" + lang + "/" + data["DefuaultCategoryUrl"].toLowerCase();
                    }

                    $.each(data, function (k, level1) {

                        if (k == "Categories") {

                            var navigationMenuItemsList = "";
                            var navigationMenuMobileItemsList = "";

                            $.each(level1, function (k1, level2) {
                                var url = level2["CategoryUrl"].length > 0 ? level2["CategoryUrl"] : level2["CategoryName"].replaceAll(" ", "-").toLowerCase();
                                var categoryUrl = url.endsWith("/") ? url : url + "/";

                                var categoryName = level2["CategoryName"];

                                var navigationMenuItemActive = "";
                                var navigationMenuItemAriaCurrent = "";

                                var hidden = level2["Hidden"] === undefined ? false : level2["Hidden"];

                                $.each(level2, function (k2, level3) {

                                    if (categoryUrl.toLowerCase().replace("/", "").trim() === pages[0]) {

                                        navigationMenuItemActive = "active";
                                        navigationMenuItemAriaCurrent = 'aria-current="page"';

                                        if (pages.length === 2) {
                                            //category -> models list
                                            if (k2 === "Models") {
                                                var modelsList = "";
                                                $.each(level3, function (k3, val) {
                                                    var modelUrl = GetModelUrl(val);
                                                    var modelImage = val["ModelImage"].length > 0 ? val["ModelImage"] : "placeholder.jpg"
                                                    var hidden = val["Hidden"] === undefined ? false : val["Hidden"];
                                                    if (hidden != true) {
                                                        modelsList += ([{
                                                            modelUrl: globalVariables.basePath + "/" + lang + "/" + categoryUrl + modelUrl,
                                                            modelName: val["ModelName"],
                                                            modelImage: baseModelsImagesPath + modelImage,
                                                            modelText: val["ModelDescription"],
                                                            buttonText: modelButtonText
                                                        }].map(modelTemplate));
                                                    }
                                                });
                                                $("#models").append(modelsList);
                                                $(".ae-brochures-container").remove();
                                            }
                                        }

                                        if (pages.length > 2) {
                                            //model -> brochures list
                                            if (k2 === "Models") {
                                                $.each(level3, function (k3, level4) {
                                                    var modelUrl = GetModelUrl(level4);

                                                    if (modelUrl.toLowerCase().replace("/", "").trim() === pages[1]) {

                                                        $(".ae-brochures-container h2").html(level4["ModelName"]);

                                                        $.each(level4, function (k4, level5) {

                                                            if (k4 === "Brochures") {
                                                                var brochuresList = "";
                                                                $.each(level5, function (k5, val) {
                                                                    var brochurePreview = val["BrochurePreview"].length > 0 ? val["BrochurePreview"] : "placeholder.jpg"
                                                                    var docUrl = val["BrochureDocument"].length > 0 ? baseBrochurePath.replace("{0}", lang) + val["BrochureDocument"] : "#";
                                                                    var hidden = val["Hidden"] === undefined ? false : val["Hidden"];
                                                                    if (hidden != true) {
                                                                        brochuresList += ([{
                                                                            documentUrl: docUrl,
                                                                            shareUrl: window.location.origin + docUrl,
                                                                            shareText: $(".ae-intro-container h1").text() + ": " + val["BrochureName"],
                                                                            documentPreview: basePreviewPath.replace("{0}", lang) + brochurePreview,
                                                                            documentText: val["BrochureName"],
                                                                            documentSize: val["BrochureSize"],
                                                                            buttonDownloadText: brochureDownloadButtonText,
                                                                            buttonShareText: brochureShareButtonText,
                                                                            disabled: val["BrochurePreview"].length === 0 ? "disabled" : ""
                                                                        }].map(brochureTemplate));
                                                                    }
                                                                });
                                                                $("#brochures").append(brochuresList);

                                                                $.getScript("https://static.addtoany.com/menu/page.js");
                                                            }
                                                        });


                                                    }
                                                });
                                                $(".ae-models-container").remove();
                                            }
                                        }

                                    }
                                });

                                if (hidden != true) {
                                    navigationMenuItemsList += ([{
                                        linkText: categoryName,
                                        linkUrl: globalVariables.basePath + "/" + lang + "/" + categoryUrl,
                                        iconUrl: baseMenuIconsPath + level2["CategoryIcon"],
                                        activeClass: navigationMenuItemActive,
                                        ariaCurrent: navigationMenuItemAriaCurrent
                                    }].map(navigationMenuItem));
                                }

                                if (navigationMenuItemActive) {

                                    $("#navigationMenuMobileToggle").append(
                                        [{
                                            linkText: categoryName,
                                            iconUrl: baseMenuIconsPath + level2["CategoryIcon"]
                                        }].map(navigationMenuMobileSelectedItem)
                                    );
                                } else {
                                    if (hidden != true) {
                                        navigationMenuMobileItemsList += ([{
                                            linkText: categoryName,
                                            linkUrl: globalVariables.basePath + "/" + lang + "/" + categoryUrl,
                                            iconUrl: baseMenuIconsPath + level2["CategoryIcon"]
                                        }].map(navigationMenuMobileItem));
                                    }
                                }
                            });

                            $("#navigationMenu").append(navigationMenuItemsList);
                            $("#navigationMenuMobile").append(navigationMenuMobileItemsList);
                        }
                    });

                    $(".ae-content").addClass("ae-loaded");
                }).fail(function () {
                    console.log("Json read fail");
                    $(".ae-content").addClass("ae-loaded");
                });
            }

            $(document).ready(function () {
                ReadJson(window.globalVariables.lang);
            });

            function GetModelUrl(val) {
                var url = val["ModelUrl"].length > 0 ? val["ModelUrl"] : val["ModelName"].replaceAll(" ", "-").toLowerCase();
                return url.endsWith("/") ? url : url + "/";
            }
        }

        if (!window.aeMain) {
            window.aeMain = new AeMain();
        } else {
            console.warn("aeMain already exist in the global object.");
        }
    }));